import { Fragment, useEffect, useState } from "react";

import { HomeFeed } from "components/home/HomeFeed";
import { LoginSplash } from "components/home/LoginSplash";
import { HomeTabSelector } from "components/home/HomeTabSelector";
import { LoadingNotice } from "components/blocks";
import { PersonalFeed } from "components/home/PersonalFeed";
import { WithSideAds } from "components/ads";
import { useMeQuery } from "queries";

import "./HomePage.scss";
import { HomepageSkyscraperEnum } from "components/ads/config/units/homepageSkyscraper";

const TRENDING_TAB = "Trending";
const PERSONAL_TAB = "For You";

export const HomePage = () => {
  const [tab, setTab] = useState<string>(TRENDING_TAB);
  const [userName, setUserName] = useState<string|null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const me = useMeQuery();

  useEffect(() => {
    if (me.status === "success" && me.data) {
      setUserName(me.data.username);
      setTab(PERSONAL_TAB);
    }

    setIsLoaded(!me.isLoading);
  }, [me.status, me.data, me.isLoading]);

  // useEffect(() => {
  //   metrics.sendGifClick({
  //     position: 1,
  //     source: "homeTrending",
  //   });

  //   // eslint-disable-next-line
  // }, []);

  document.title = "RedGIFs - Free Porn GIFs and Pics";

  const changeTab = (value: string): void => {
    setTab(value);
  };

  return (
    <WithSideAds
      leftAds={[
        HomepageSkyscraperEnum.HomepageSkyscraperL1,
      ]}
      rightAds={[
        HomepageSkyscraperEnum.HomepageSkyscraperR1,
      ]}
    >
      <div className="page homePage">
        <HomeTabSelector
          tab={tab}
          onChange={changeTab}
        />

        {me.isLoading && (
          <LoadingNotice />
        )}

        {
          isLoaded && (
            <Fragment>
              {tab === TRENDING_TAB && <HomeFeed />}
              {tab === PERSONAL_TAB && userName && <PersonalFeed />}
              {tab === PERSONAL_TAB && !userName && <LoginSplash />}
            </Fragment>
          )
        }
      </div>
    </WithSideAds>
  );
};
